import { useContext } from 'react';

import { GlobalStateContext } from './context';

export const useGlobalState = () => {
  return useContext(GlobalStateContext);
};
